"use client";

import { Toast, ToastDescription, ToastProvider, ToastTitle, ToastViewport } from "@/components/ui/toast";
import { useToast } from "@/components/ui/use-toast";
import { FC } from "react";

// Toast の className をセットできるようにする。
type ToasterProps = { toastClassName?: string };

export const Toaster: FC<ToasterProps> = (props) => {
  const { toasts } = useToast();
  const { toastClassName } = props;

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, ...props }) {
        return (
          <Toast key={id} {...props} className={toastClassName}>
            <div className="grid gap-1">
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && <ToastDescription>{description}</ToastDescription>}
            </div>
            {action}
            {/* xボタンは非表示にする */}
            {/* <ToastClose /> */}
          </Toast>
        );
      })}

      {/* 表示位置を中央下にする */}
      {/* <ToastViewport /> */}
      <ToastViewport className="bottom-auto top-0 sm:inset-x-0 sm:bottom-auto sm:top-0 sm:mx-auto" />
    </ToastProvider>
  );
};
